import CloseIcon from '@mui/icons-material/Close';
import { Box, IconButton, Paper, Skeleton, Tooltip, Typography } from '@mui/material';
import ModalMAIQ from 'app/components/ModalMAIQ';
import { useMetricL2Modal } from '../hooks/useMetricL2Modal';
import { rendererMap } from '../registry/rendererMap';
import { isTileEmptyStatus } from '../utils/tileFetchError';
import TileErrorCard from './TileErrorCard';

/** Presentational L2 drilldown shell — logic in useMetricL2Modal. Uses ModalMAIQ. */
export default function MetricL2Modal() {
  const { open, metricId, config, data, isLoading, error, statusCode, title, onClose } =
    useMetricL2Modal();

  const rendererKey = config?.renderer;
  const Renderer = rendererKey ? rendererMap[rendererKey] : null;

  return (
    <ModalMAIQ open={open} onClose={onClose} hideDefaultCloseButton>
      <Paper
        elevation={0}
        sx={{
          width: 920,
          maxWidth: '92vw',
          maxHeight: '85vh',
          display: 'flex',
          flexDirection: 'column',
          borderRadius: 0,
        }}
      >
        <Box
          className="modal-header"
          sx={{
            p: 2,
            zIndex: 10,
            flexShrink: 0,
          }}
        >
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            width="100%"
          >
            <Box>
              <Typography variant="h6" fontWeight={600}>
                {title}
              </Typography>
              <Typography variant="caption" sx={{ opacity: 0.85 }}>
                Detailed view
              </Typography>
            </Box>
            <Tooltip title="Close">
              <IconButton
                className="modal-header-button"
                aria-label="close"
                onClick={onClose}
                size="small"
              >
                <CloseIcon fontSize="small" />
              </IconButton>
            </Tooltip>
          </Box>
        </Box>

        <Box sx={{ px: 0, pt: 0, pb: 0, overflow: 'auto', flex: 1, minHeight: 0 }}>
          {isLoading ? (
            <Skeleton variant="rounded" height={280} sx={{ borderRadius: 2 }} />
          ) : null}

          {!isLoading && (error || isTileEmptyStatus(statusCode)) ? (
            <TileErrorCard
              message={error}
              statusCode={statusCode}
              height={220}
              title={title}
              query={data?.meta?.query}
              registry={data?.meta?.registry}
              renderer={rendererKey}
              span="full"
            />
          ) : null}

          {!isLoading && !error && !isTileEmptyStatus(statusCode) && config && data && Renderer ? (
            <Renderer config={config} data={data} span="full" metricId={metricId} />
          ) : null}

          {!isLoading && !error && !isTileEmptyStatus(statusCode) && open && (!config || !Renderer) ? (
            <Typography variant="body2" sx={{ color: 'text.secondary' }}>
              Unable to render this metric.
            </Typography>
          ) : null}
        </Box>
      </Paper>
    </ModalMAIQ>
  );
}
